import { render, staticRenderFns } from "./TypesList.vue?vue&type=template&id=1838854a&scoped=true"
import script from "./TypesList.vue?vue&type=script&lang=js"
export * from "./TypesList.vue?vue&type=script&lang=js"
import style0 from "./TypesList.vue?vue&type=style&index=0&id=1838854a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1838854a",
  null
  
)

export default component.exports